import { Phone, MessageCircle } from "lucide-react";
import { WHATSAPP_URL, CALL_URL, trackWhatsAppClick, trackCallClick } from "@/lib/constants";

export default function MobileBottomBar() {
  return (
    <div data-testid="mobile-bottom-bar" className="fixed bottom-0 left-0 right-0 z-40 sm:hidden bg-white border-t border-stone-200 shadow-[0_-4px_12px_rgba(0,0,0,0.1)]">
      <div className="grid grid-cols-2 divide-x divide-stone-200">
        <a
          href={CALL_URL}
          data-testid="mobile-bar-call"
          onClick={() => trackCallClick(CALL_URL)}
          className="flex items-center justify-center gap-2 py-3.5 bg-[#b22300] text-white font-semibold text-sm"
        >
          <Phone className="w-4 h-4" />
          Call Now
        </a>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-whatsapp"
          onClick={trackWhatsAppClick}
          className="flex items-center justify-center gap-2 py-3.5 bg-[#25D366] text-white font-semibold text-sm"
        >
          <MessageCircle className="w-4 h-4" />
          WhatsApp
        </a>
      </div>
    </div>
  );
}
